import axios from 'axios';

export default {
    async getRestaurants(urlParams) {
        return axios.get(`api/restaurants`, { params: urlParams });
    },
    async createRestaurant(dataParams) {
        return axios.post(`api/restaurants`, dataParams);
    },
    async getRestaurant(restaurantId) {
        return axios.get(`api/restaurants/${restaurantId}`);
    },
    async updateRestaurant(restaurantId, dataParams) {
        return axios.put(`api/restaurants/${restaurantId}`, dataParams);
    },
    async deleteRestaurant(restaurantId) {
        return axios.delete(`api/restaurants/${restaurantId}`);
    },
    async createRestaurantOrder(restaurantId, dataParams) {
        return axios.post(`api/restaurants/${restaurantId}/orders`, dataParams);
    },
    async getRestaurantOrders(restaurantId, urlParams = null) {
        return axios.get(`api/restaurants/${restaurantId}/orders`, {
            params: urlParams
        });
    },
    async getSettlementDetails(restaurantId, date, includePendingList = false) {
        return axios.get(`api/restaurants/${restaurantId}/settlement-details`, {
            params: {
                date: date,
                include_pending_list: includePendingList ? 1 : 0
            }
        });
    },
    async getAllPendingSettlements(restaurantId, page = 1) {
        return axios.get(`api/rest/pending-settlements`, {
            params: {
                restaurant_id: restaurantId,
                page: page
            }
        });
    },
    async setSettled(settlementId, isSettled) {
        const dataParams = { is_settled: isSettled ? 1 : 0 };
        return axios.post(
            `api/settlements/${settlementId}/set-settled`,
            dataParams
        );
    },
    async setSettledForMultipleIds(settlementIds) {
        const dataParams = { settlement_ids: settlementIds };
        // await new Promise(resolve => setTimeout(resolve, 3000));
        return axios.post(`api/settlements/set-settled`, dataParams);
    },
    async setSettledForRestaurant(restId) {
        const dataParams = { restaurant_id: restId };
        return axios.post(
            'api/settlements/set-settled-by-restaurant',
            dataParams
        );
    },
    async getAllRestaurantHavingPendingSettlement() {
        return axios.get('api/restaurants/pending-settlements');
    }
};
